import {
  AGGREGATIONS_ACCUMULATED_SELECTABLE_MODE,
  AGGREGATIONS_AVERAGE_SELECTABLE_MODE,
  AGGREGATIONS_COMPETITION_AVERAGE_SELECTABLE_MODE,
  AGGREGATIONS_MATCH_SELECTABLE_MODE,
  AGGREGATIONS_MODES,
  COMMON_AGGREGATION_MODES
} from '../constants/aggregation.constants'
import { Aggregation, AggregationSelectable } from '../models/aggregations.models'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import {
  selectAggregationsLeftAggregation,
  selectAggregationsRightAggregation
} from '@features/aggregations/store/selectors/aggregations.selectors'
import { selectTeamAggregationsModes } from '@pages/team/store/selectors/team.selectors'
import { setAggregations } from '@features/aggregations/store/actions/aggregations.actions'

export const resolveAggregationModeList = (isMatch: boolean): AggregationSelectable[] => {
  const conditionalModes: AggregationSelectable[] = []

  if (isMatch) {
    conditionalModes.push(AGGREGATIONS_MATCH_SELECTABLE_MODE)
  }

  return [...conditionalModes, ...COMMON_AGGREGATION_MODES]
}

export const buildComparisonAggregationByContext = (isComparison: boolean) => {
  return isComparison ? AGGREGATIONS_AVERAGE_SELECTABLE_MODE : AGGREGATIONS_COMPETITION_AVERAGE_SELECTABLE_MODE
}

export const getAggregationAsSelectable = (aggregation: Aggregation): AggregationSelectable => {
  return AGGREGATIONS_MODES.find((agg) => agg.id === aggregation)
}

export const getAggregationSelectors = (
  _store: Store
): [Observable<AggregationSelectable>, Observable<AggregationSelectable>, Observable<AggregationSelectable[]>] => {
  return [
    _store.select(selectAggregationsLeftAggregation),
    _store.select(selectAggregationsRightAggregation),
    _store.select(selectTeamAggregationsModes)
  ]
}

export const syncTeamAggregations = (
  _store: Store,
  leftAggregation: AggregationSelectable,
  rightAggregation: AggregationSelectable,
  aggregationModes: AggregationSelectable[]
): void => {
  const right = aggregationModes?.some((agg) => agg.id === rightAggregation?.id)
    ? rightAggregation
    : AGGREGATIONS_ACCUMULATED_SELECTABLE_MODE

  _store.dispatch(setAggregations({ leftAggregation, rightAggregation: right }))
}
